export default "__VITE_ASSET__GDolZqRJ__"